import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b548bff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = ["data-edit", "innerHTML"]

import { vMove, vInput, useCover } from './index';
import { hexToRgba } from '../pc-module-border';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cover-1',
  props: {
    useEdit: { type: Boolean },
    projectName: {},
    time: {},
    mainPageEnterpriseName: {},
    titlePosition: {},
    settleTimePosition: {},
    aspNamePosition: {},
    orderNumber: {},
    orderNumberPostion: {}
  },
  emits: ['posChange', 'valueChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const { info, onPosChange, onValueChange } = useCover(emits);

document.documentElement.style.setProperty(
  '--theme-color-1-for-cover-1',
  hexToRgba(
    document.documentElement.style.getPropertyValue('--theme-color-1'),
    0.5
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "data-edit": _ctx.useEdit,
        key: index,
        class: _normalizeClass(item.className),
        innerHTML: props[item.valueKey]
      }, null, 10, _hoisted_2)), [
        [_unref(vMove), {
        pos: props[item.posKey],
        change: (left, top) => _unref(onPosChange)(item.posKey, left, top)
      }],
        [_unref(vInput), {
        value: props[item.valueKey],
        change: (value) => _unref(onValueChange)(item.valueKey, value)
      }]
      ])
    }), 128))
  ]))
}
}

})